
import { writable } from 'svelte/store';

export const message_ = writable("");

message_.subscribe(val=>{
    console.log("Message",val)
})